"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextAndPillWrapper = exports.StyledGuidedSellingWrapper = exports.PageWrapper = exports.OnlineDiscountPill = exports.MainTextWrapper = exports.LightBackground = exports.HoverDisableWrapper = exports.GrayBackground = exports.FlexItem = exports.FlexContainer = exports.BorderWrapper = exports.BodyBackground = exports.AlignContainer = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable @typescript-eslint/no-explicit-any */

const LightBackground = component => (0, _styledComponents.default)(component)(() => (0, _styledComponents.css)`
      background-color: #ffffff;
    `);
exports.LightBackground = LightBackground;
const GrayBackground = component => (0, _styledComponents.default)(component)(() => (0, _styledComponents.css)`
      background-color: #f4f4f4;
    `);
exports.GrayBackground = GrayBackground;
const BodyBackground = component => (0, _styledComponents.default)(component)(props => {
  return (0, _styledComponents.css)`
      background-color: ${props.color || '#f4f4f4'};
    `;
});
exports.BodyBackground = BodyBackground;
const StyledGuidedSellingWrapper = _styledComponents.default.div`
  height: 0px;
`;
exports.StyledGuidedSellingWrapper = StyledGuidedSellingWrapper;
const HoverDisableWrapper = _styledComponents.default.div`
  ${props => (0, _styledComponents.css)`
      button {
        background: ${props => props.theme.backgroundColor} ${props.mdAndBelow && '!important'};
        color: ${props => props.theme.color} ${props.mdAndBelow && '!important'};
        border-color: ${props => props.theme.borderColor} ${props.mdAndBelow && '!important'};
      }
      button:hover,
      button:active {
        box-shadow: ${props => {
  var _props$theme, _props$theme$hover;
  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$hover = _props$theme.hover) === null || _props$theme$hover === void 0 ? void 0 : _props$theme$hover.boxShadow;
}} !important;
      }
      button:focus {
        outline: none;
        box-shadow: ${props => {
  var _props$theme2, _props$theme2$hover;
  return (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : (_props$theme2$hover = _props$theme2.hover) === null || _props$theme2$hover === void 0 ? void 0 : _props$theme2$hover.boxShadow;
}};
      }
    `}
`;

// --------------- Generic Components -------------------

//Prop types

//Component prop types
exports.HoverDisableWrapper = HoverDisableWrapper;
//Components
const FlexContainer = _styledComponents.default.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  gap: ${props => props.gap};
  flex: ${props => props.flex};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  ${props => props.styleOverrides}
`;
exports.FlexContainer = FlexContainer;
const FlexItem = _styledComponents.default.div`
  flex-basis: ${props => props.flexBasis};
  flex-grow: ${props => props.flexGrow};
  flex-shrink: ${props => props.flexShrink};
  flex: ${props => props.flex};
  padding: ${props => {
  var _props$padding$top, _props$padding, _props$padding$right, _props$padding2, _props$padding$bottom, _props$padding3, _props$padding$left, _props$padding4;
  return `${(_props$padding$top = (_props$padding = props.padding) === null || _props$padding === void 0 ? void 0 : _props$padding.top) !== null && _props$padding$top !== void 0 ? _props$padding$top : 0}px ${(_props$padding$right = (_props$padding2 = props.padding) === null || _props$padding2 === void 0 ? void 0 : _props$padding2.right) !== null && _props$padding$right !== void 0 ? _props$padding$right : 0}px ${(_props$padding$bottom = (_props$padding3 = props.padding) === null || _props$padding3 === void 0 ? void 0 : _props$padding3.bottom) !== null && _props$padding$bottom !== void 0 ? _props$padding$bottom : 0}px ${(_props$padding$left = (_props$padding4 = props.padding) === null || _props$padding4 === void 0 ? void 0 : _props$padding4.left) !== null && _props$padding$left !== void 0 ? _props$padding$left : 0}px `;
}};
  text-align: ${props => props.align};  
`;
exports.FlexItem = FlexItem;
const BorderWrapper = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
  gap: 40px;
  padding: ${props => {
  var _props$padding5;
  return (_props$padding5 = props.padding) !== null && _props$padding5 !== void 0 ? _props$padding5 : '20px 24px 40px 24px';
}};
`;
exports.BorderWrapper = BorderWrapper;
const PageWrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.gap}px;
`;
exports.PageWrapper = PageWrapper;
const AlignContainer = (0, _styledComponents.default)(FlexItem)`
  text-align: ${props => props.breakPoints.sm ? 'left' : props.alignItems ? props.alignItems : 'center'};
`;
exports.AlignContainer = AlignContainer;
const MainTextWrapper = _styledComponents.default.div`
  display: flex;
  align-items: ${props => props.breakPoints.sm ? 'flex-start' : 'flex-end'};
  justify-content: ${props => props.breakPoints.sm ? 'flex-start' : 'flex-end'};
`;
exports.MainTextWrapper = MainTextWrapper;
const TextAndPillWrapper = _styledComponents.default.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column-reverse;

  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      flex-direction: row;
      align-items: center;
    `)}
`;
exports.TextAndPillWrapper = TextAndPillWrapper;
const OnlineDiscountPill = _styledComponents.default.div`
  background-color: #42e8b4;
  padding: 2px 4px;
  width: max-content;
  color: #000000;
  border-radius: 3px;
  display: inline-block;
`;
exports.OnlineDiscountPill = OnlineDiscountPill;